<div class="numero_piezas">{{ numeroSolicitudes }}</div>
<div class="descripcion pendiente-de-validación">DISEÑOS DIGITALES PENDIENTES DE VALIDAR</div>
